exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media only screen and (min-width: 280px) and (max-width:425px)  {\n   \n    .backarrow{\n        position: absolute!important;\n    }\n  \n\n}\n\n.vmtypebtn{\n    border-style: dotted!important;\n    box-shadow:none!important;\n    margin: 0px!important;\n    font-size: 1.5rem!important;\n   /*  padding-left: 0rem!important;\n    padding-right: 0rem!important; */\n\n}\n/* .item .text{\n    font-size: 20px;\n} */\n.field >label{\n\n    margin-bottom: 1rem!important;\n    font-size: 18px!important;\n    color: rgb(96 96 96 / 87%)!important;\n\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/Modules/VMCreate/VMCreate.css
// module id = 1586
// module chunks = 0